import { render, staticRenderFns } from "./SimpleSlice.vue?vue&type=template&id=30217811&"
import script from "./SimpleSlice.vue?vue&type=script&lang=js&"
export * from "./SimpleSlice.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSlice.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports